export default __webpack_public_path__ + "static/media/social-face.1e1c5d3d.svg";